import { useState, useEffect } from 'react';
import { registerPanel, closeOtherPanels } from './panelCoordinator';

let listeners = [];
let state = {
  isOpen: false,
  diagramXml: null,
  diagramTitle: null,
  diagramType: null,
};

const notify = () => listeners.forEach(l => l({ ...state }));

export const diagramEditor = {
  open: (xml, title, diagramType = null) => {
    if (state.isOpen && state.diagramXml === xml) return;
    const hadOther = closeOtherPanels('diagram');
    if (state.isOpen || hadOther) {
      state = { isOpen: false, diagramXml: null, diagramTitle: null, diagramType: null };
      notify();
      setTimeout(() => {
        state = { isOpen: true, diagramXml: xml, diagramTitle: title || 'Diagram', diagramType };
        notify();
      }, 350);
      return;
    }
    state = { isOpen: true, diagramXml: xml, diagramTitle: title || 'Diagram', diagramType };
    notify();
  },

  close: () => {
    state = { isOpen: false, diagramXml: null, diagramTitle: null, diagramType: null };
    notify();
  },

  updateXml: (xml) => {
    state = { ...state, diagramXml: xml };
    notify();
  },

  getState: () => ({ ...state }),
};

registerPanel('diagram', () => {
  if (!state.isOpen) return false;
  diagramEditor.close();
  return true;
});

export const useDiagramEditor = () => {
  const [editorState, setEditorState] = useState({ ...state });

  useEffect(() => {
    const handler = (s) => setEditorState(s);
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(l => l !== handler);
    };
  }, []);

  return {
    ...editorState,
    open: diagramEditor.open,
    close: diagramEditor.close,
    updateXml: diagramEditor.updateXml,
  };
};

export default useDiagramEditor;
